import React from 'react';
import PropTypes from 'prop-types';
// import Search from './Search';
import NewSearch from './NewSearch';
import LocalizedStrings from './localization.js';
import TagService from '../../apiclients/TagService';

let tagQueryCounter = 0;
class Tagger extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isTagSearchLoading: false,
            currentTag: '',
            results: { 'tags': { 'name': LocalizedStrings.existingTags, 'results': [] }, 'new': { 'name': LocalizedStrings.createTag, 'results': [] }, },
        };

        //BINDINGS
        this.handleSelectedResult = this.handleSelectedResult.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    handleSelectedResult(values) {
        this.setState({ currentTag: '' });
        this.props.onResultSelected(values);
    }

    handleSearchChange(value, e) {
        if (e.action !== 'input-change') return;
        this.setState({ isTagSearchLoading: true, currentTag: value });
        if (value === '') {
            this.setState({ isTagSearchLoading: false });
            return;
        }
        let lastQueryId = ++tagQueryCounter;
       
        TagService.getTags(
            value
        ).then((data) => {
            if (lastQueryId !== tagQueryCounter) return;
            let newResults = Object.assign({}, this.state.results);
            newResults.tags.results = [];
            data.items.forEach(function (tag) {
                newResults.tags.results.push({
                    'title': tag, 'label': tag, 'value': tag,
                });
            });
            newResults.new.results = [{ 'title': value, 'label': value, 'value': value, }];
            this.setState({ isTagSearchLoading: false, results: newResults });

        }).catch((err) => {
            if (lastQueryId !== tagQueryCounter) return;
            console.log('err');
            console.log(err);
        });
    }

    render() {
        return (
            <div data-id="library-tagger">
                <NewSearch
                    usePortal={this.props.usePortal}
                    isMulti={true}
                    placeholder={LocalizedStrings.tagFilesPlaceholder}
                    takeRef={this.props.takeRef}
                    isLoading={this.state.isTagSearchLoading}
                    value={this.state.currentTag}
                    onResultSelect={this.handleSelectedResult}
                    onSearchChange={this.handleSearchChange}
                    firstResults={this.state.results.tags}
                    secondResults={this.state.results.new}
                />
            </div>
        );
    }
};

Tagger.propTypes = {
    usePortal: PropTypes.bool,
    onResultSelected: PropTypes.func.isRequired,
    takeRef: PropTypes.func,
};

export default Tagger;